export default __webpack_public_path__ + "static/media/instagram.56963f81.svg";